 import { Input } from "@headlessui/react";
import type React from "react";
import { forwardRef } from "react";

export const FormInput = forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>((props, ref) => {
  return (
    <Input
      ref={ref}
      {...props}
      className={`
          w-full rounded-sm border px-2 py-1 text-sm
          placeholder:text-gray-400 bg-transparent

          border-gray-300 text-gray-800

          focus-visible:outline-none
          focus-visible:ring-1
          focus-visible:ring-blue-500

          data-[invalid]:border-error-500
          data-[invalid]:focus-visible:ring-error-500/20
          data-[invalid]:focus-visible:border-error-300

          data-[disabled]:bg-gray-100
          data-[disabled]:text-gray-500
          data-[disabled]:cursor-not-allowed
          data-[disabled]:opacity-40
        `}
    />
  );
});
